import React from 'react'
import { useTranslation } from 'react-i18next'

function ActiveIcon({children,passedValue,defaultValue,handleStyleType,property,layout, spacing, activeStyle,inActiveStyle,labelStyle,labelPosition}) {
    const { t } = useTranslation(['styles', 'translation']);
    const defaultInactiveStyle={
        border:"1px solid #dadada"
    }
    const defaultActiveStyle={
        border:"1px solid #0072c6",
        background:"#0072C60D",
        borderRadius:"2px"      
    }
    const defaultStyle={
        display:"inline-block",
        padding:"5px",
        textAlign:"center",
        margin:spacing ? `0px ${spacing}`: "0px",
        cursor:"pointer",
        width:"100%"              
    }
    const mainStyle={
        display:"grid",
        gridTemplateColumns: `repeat(${layout},auto)`,
        margin: '5px 0',
        // gridGap:"0"
    }
    const deflabelStyle={
        textAlign:"center",
        margin:"0"
    }
    const activeLabelStyle={
        color:(activeStyle && activeStyle.color)|| "#0072C6"
    }

    return (
        <div style={layout ? mainStyle: null}>
                    
                    {children.map(child=>{
                        return(
                            <div style={{display:'inline-block',justifySelf:"center" }}>

                                <div style={child.props.value===passedValue || (passedValue==="" && child.props.value===defaultValue) 
                                    || (passedValue===undefined && child.props.value===defaultValue) 
                                    ? {...defaultActiveStyle, ...defaultStyle,...activeStyle,direction:"ltr"} : {...defaultInactiveStyle, ...defaultStyle,...inActiveStyle,direction:"ltr"} } 
                                    onClick={property? ()=>handleStyleType(property,child.props.value) : ()=>handleStyleType(child.props.value) } >

                                            {child}
                                            {child.props.label && labelPosition==="in" && <p style={child.props.value===passedValue || (passedValue==="" && child.props.value===defaultValue) 
                                    || (passedValue===undefined && child.props.value===defaultValue) 
                                    ? {...deflabelStyle, ...labelStyle,...activeLabelStyle} : {...deflabelStyle, ...labelStyle} }
                                >  {t(`translation:${child.props.label}`)} </p>}

                                </div>

                                {child.props.label && labelPosition!=="in" && 
                                <p style={child.props.value===passedValue || (passedValue==="" && child.props.value===defaultValue) 
                                    || (passedValue===undefined && child.props.value===defaultValue) 
                                    ? {...deflabelStyle, ...labelStyle,...activeLabelStyle} : {...deflabelStyle, ...labelStyle} }
                                >  {t(`translation:${child.props.label}`)} </p>}

                            </div>
                        )
                    })}
                    
        </div>
    )
}

export default ActiveIcon
